export default { trips: [] };
